import { emptyReasonNotStarted } from "../../dictionaries/CodeSystemLookup";

const adjustEmptyReason = (sectionState, setSectionState) => {
    let autoChangedEmptyReasonChanged = "no change";
    let sectionIsEmpty = true;
    if (sectionState.section?.length) {
        sectionIsEmpty = false;
    } else if (sectionState.entry?.length) {
        sectionIsEmpty = false;
    } else if (sectionState.text?.status && sectionState.text.status !== "empty") {
        sectionIsEmpty = false;
    }
    if (sectionIsEmpty && !sectionState.emptyReason) {
        autoChangedEmptyReasonChanged = JSON.parse(JSON.stringify(emptyReasonNotStarted));
        setSectionState(prevState => { return { ...prevState, "emptyReason": autoChangedEmptyReasonChanged }; });
    }
    if (!sectionIsEmpty && sectionState.emptyReason) {
        autoChangedEmptyReasonChanged = null;
        setSectionState(prevState => { return { ...prevState, "emptyReason": null }; });
    }
    return autoChangedEmptyReasonChanged;
}

export default adjustEmptyReason;